var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "card-box" },
      [
        _c(
          "el-card",
          {
            staticClass: "box-card",
            attrs: { "body-style": { padding: "20px 20px 0" } },
          },
          [
            _c(
              "div",
              { staticClass: "setting-container" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", _vm._b({}, "el-col", _vm.grid1, false), [
                      _vm._v(" "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      _vm._b({}, "el-col", _vm.grid2, false),
                      [
                        _c(
                          "el-form",
                          {
                            ref: "elForm",
                            attrs: {
                              model: _vm.formData,
                              rules: _vm.rules,
                              "label-width": "200px",
                              size: "medium",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-list" },
                              [
                                _c("div", { staticClass: "head" }, [
                                  _c("span", { staticClass: "line" }, [
                                    _vm._v("|"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("自动退回公海"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "自动退回公海：",
                                      prop: "return_high_seas_switch",
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "active-color": "#1890ff",
                                        "active-text": "开启",
                                        "inactive-color": "#909399",
                                        "inactive-text": "关闭",
                                      },
                                      model: {
                                        value:
                                          _vm.formData.return_high_seas_switch,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "return_high_seas_switch",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.return_high_seas_switch",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.formData.return_high_seas_switch
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "未成交退回：",
                                            prop: "unsettled_cycle",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入正整数",
                                                "show-word-limit": "",
                                                size: "small",
                                                type: "number",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.unsettled_cycle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "unsettled_cycle",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.unsettled_cycle",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "suffix" },
                                                [_vm._v("天")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "info" }, [
                                            _vm._v(
                                              "用于设置客户在未成交状态滞留多少天自动退回公海"
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "未跟进退回：",
                                            prop: "unfollowed_cycle",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入正整数",
                                                "show-word-limit": "",
                                                size: "small",
                                                type: "number",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.unfollowed_cycle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "unfollowed_cycle",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.unfollowed_cycle",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "suffix" },
                                                [_vm._v("天")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "info" }, [
                                            _vm._v(
                                              "用于设置未成交状态的客户，多少天未跟进自动退回公海"
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "退回公海提醒：",
                                            prop: "advance_cycle",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入正整数",
                                                "show-word-limit": "",
                                                size: "small",
                                                type: "number",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.advance_cycle,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "advance_cycle",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.advance_cycle",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "suffix" },
                                                [_vm._v("天")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "info" }, [
                                            _vm._v(
                                              "用于客户退回公海提前多少天进行提醒"
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card-list mt30" },
                              [
                                _c("div", { staticClass: "head" }, [
                                  _c("span", { staticClass: "line" }, [
                                    _vm._v("|"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "title" }, [
                                    _vm._v("客户保单规则"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "客户保单规则：",
                                      prop: "client_policy_switch",
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "active-color": "#1890ff",
                                        "active-text": "开启",
                                        "inactive-color": "#909399",
                                        "inactive-text": "关闭",
                                      },
                                      model: {
                                        value:
                                          _vm.formData.client_policy_switch,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "client_policy_switch",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.client_policy_switch",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.formData.client_policy_switch
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "保单数量：",
                                            prop: "unsettled_client_number",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticStyle: { width: "350px" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入正整数",
                                                "show-word-limit": "",
                                                size: "small",
                                                type: "number",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData
                                                    .unsettled_client_number,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "unsettled_client_number",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.unsettled_client_number",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "suffix" },
                                                [_vm._v("个")]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "info" }, [
                                            _vm._v(
                                              "用于设置每个销售员最多可以拥有多少个暂未成交状态的客户"
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "primary" },
                                    on: { click: _vm.saveEvt },
                                  },
                                  [_vm._v("保存")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }